import React, { useEffect, useState } from 'react'
import upload from '../../Image/upload.png';
import workpermit from '../../Image/KbIYw3csEXcJqNmDZRoGJkBHEry4Izk0.webp'
import HomeServices from '../../Services/HomeServices';
import toast from 'react-hot-toast';
import HttpClientXml from '../../utils/HttpClientXml';
import { useSelector } from 'react-redux';
const ServiceAccordion = () => {
  const { user } = useSelector(state => state.auth);
  const [imageUpload, setImageUpload] = useState(false)
  const [allData, setAllData] = useState([])

  console.log("GFD13",user);
  

  const fetchData = async () => {
    try {
      const res = await HomeServices.getAllAssignedServices();
      console.log("DFFE12", res.data);
      // return
      if (res && res.status) {
        setAllData(res.data)
      } else {
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  }


  //////////////////File Upload//////////////////////
  const [loadingFile, setLoadingFile] = useState("")
  const [uploadedFile, setUploadedFile] = useState("")
  const [imgPos, setImgPos] = useState({})
  // Update file name when file is selected
  const handleFileChange = async (e, k1, k2, assignedServiceId, serviceId, documentId) => {
    console.log("BGF31", k1, k2);
    setImgPos({ a: k1, b: k2 });


    // const fileName = event.target.files[0]?.name || '';
    setLoadingFile("Uploading document. Please wait...")

    /////Uploading Single Image////
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode(
        "image-upload",
        "POST",
        formData
      );

      if (res && res.status) {
        setUploadedFile(res?.data?.url);
        // setLoadingFile("")
        // return
        ////Upload Document///////
        //item?.ServiceData?._id, item?.serviceId, doc?._id
        //assignedServiceId,serviceId,documentId,
        const formData = {
          userId: user?._id,
          assignedServiceId: assignedServiceId,
          serviceId: serviceId,
          documentId: documentId,
          file: res?.data?.url,
          //uploadedBy: "user"
        }

        // console.log("WFGN290",formData);
        // return

        try {
          const res = await HttpClientXml.requestRawData("upload-documents", formData, 'POST')
          console.log("DFER72", res);
          // return
          if (res && res.status) {
            toast.success(res?.message);
            fetchData()
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.error("Error uploading document:", error);
          toast.error("Document upload failed.");
        }
        ///////////////////////
      } else {
        // toast.error(res?.message || "Image upload failed");
        console.error("Error uploading image:", res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // toast.error("Image upload failed");
    }
    //////////////////////////////

    setLoadingFile("")
  };

  ///////////////////////////////////////////////////

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <div class="accordion" id="accordionExample">
        {
          allData
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map((item, key) => {
              return (
                <>
                  <div class="accordion-item" key={key}>
                    <h2 class="accordion-header" id={`heading${key}`}>
                      <button class="accordion-button multi-line-btn" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${key}`} aria-expanded="true" aria-controls="collapseOne"
                      style={{}}
                      >
                        {item?.ServiceData?.serviceName}<br/> <span style={{fontSize:"18px",display: "contents"}}>Service# : {item?.assignNo||"N/A"}, Status : {item?.assignStatus||"N/A"}</span>
                      </button>
                      
                    </h2>
                    <div id={`collapse${key}`}
                      // class="accordion-collapse collapse _show" 
                      className={key === 0 ? "accordion-collapse collapse show" : "accordion-collapse collapse"}
                      aria-labelledby={`heading${key}`} data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        {
                          item?.ServiceData?.documents?.map((doc, key2) => {
                            return (
                              <>
                                <div className='documents_wrapper'>
                                  <label>{doc?.document}</label>
                                  <div className='upload_img_wrapper_div'>
                                    {loadingFile}
                                    {
                                      imgPos.a == key && imgPos.b == key2 ?
                                        <>
                                        <div className='small_img_wrapper'>
                                          <div className='small_img'>
                                            {/* <i class="fa-solid fa-circle-xmark"></i> */}
                                            {/* <img src={workpermit} /> */}
                                            {/* <img src={uploadedFile || workpermit}/> */}
                                            <a href={uploadedFile} target='_blank'>
                                            <img src={uploadedFile} />
                                            </a>
                                          </div>
                                          </div>
                                        </>
                                        :
                                        <>
                                          {doc?.uploadedData.length > 0 && <div className='small_img_wrapper'>
                                            <div className='small_img'>
                                              {/* <i class="fa-solid fa-circle-xmark"></i> */}
                                              {/* <img src={workpermit} /> */}
                                              {/* <img src={uploadedFile || workpermit}/> */}
                                              <a href={doc?.uploadedData[0]?.file} target='_blank'>
                                                <img src={doc?.uploadedData[0]?.file} />
                                              </a>
                                            </div>
                                          </div>}
                                        </>

                                    }

                                    {doc?.uploadedData.length === 0 && <>
                                      <img src={upload} />
                                      <h6>Click here to upload</h6>
                                      <input
                                        // onChange={(() => { setImageUpload(true) })}
                                        onChange={(e) => handleFileChange(e, key, key2, item?._id, item?.serviceId, doc?._id)}
                                        type='file'
                                      //  multiple
                                      />
                                    </>}
                                  </div>

                                </div>
                              </>
                            )
                          })
                        }






                      </div>
                    </div>
                  </div>
                </>
              )
            })
        }
        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Family-based sponsorship
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>



            </div>
          </div>
        </div> */}

        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Employment-based immigration
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>


            </div>
          </div>
        </div> */}

        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              Refugee and asylum claims
            </button>
          </h2>
          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div class="accordion-body">

              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>







            </div>
          </div>
        </div> */}

      </div>
    </>
  )
}

export default ServiceAccordion
